import { Phone, Mail, Globe, MessageCircle } from "lucide-react";

export default function AgentCard({ t, agent }) {
  const firstName = agent.name.trim().split(/\s+/)[0];
  const waMsg = `Olá ${firstName}, gostaria de mais informações sobre o Belo Horizonte Residences.`;
  const waLink = `https://wa.me/${agent.phone.replace(/[^0-9]/g, "")}?text=${encodeURIComponent(waMsg)}`;
  const telLink = `tel:${agent.phone}`;
  const mailLink = `mailto:${agent.email}?subject=${encodeURIComponent("Belo Horizonte Residences")}`;
  const websiteHost = agent.website
    .replace(/^https?:\/\//, "")
    .replace(/\/$/, "");

  return (
    <section
      id="contact"
      data-testid="agent-section"
      className="relative bg-[#F5F1EA] py-24 lg:py-40 overflow-hidden"
    >
      <div className="mx-auto max-w-[1400px] px-6 lg:px-10">
        <div className="relative bg-[#0A0A0A] text-white overflow-hidden">
          <div className="grid lg:grid-cols-12 gap-0">
            <div className="lg:col-span-5 relative min-h-[420px] lg:min-h-[620px] bg-[#141414]">
              <img
                src={agent.photo}
                alt={agent.name}
                className="absolute inset-0 w-full h-full object-cover object-top grayscale-[0.15]"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-[#0A0A0A] via-transparent to-transparent" />
            </div>

            <div className="lg:col-span-7 p-8 lg:p-16 flex flex-col justify-center">
              <div className="flex items-center gap-4 mb-6">
                <span className="h-px w-10 bg-[#BEAF87]" />
                <span className="text-[11px] uppercase tracking-[0.35em] text-[#BEAF87] font-[Barlow_Semi_Condensed] font-medium">
                  {t.agent.eyebrow}
                </span>
              </div>

              <h2
                data-testid="agent-name"
                className="font-[Cormorant_Garamond] font-light text-4xl sm:text-5xl lg:text-6xl leading-[1.05] tracking-tight"
              >
                {agent.name}
              </h2>
              <p className="mt-4 text-[#BEAF87] font-[Barlow_Semi_Condensed] tracking-wide text-sm uppercase">
                {t.agent.role}
              </p>

              <p className="mt-8 text-white/70 font-[Barlow_Semi_Condensed] max-w-lg">
                {t.agent.body}
              </p>

              <div className="mt-10 grid grid-cols-1 sm:grid-cols-2 gap-3">
                <a
                  data-testid="agent-whatsapp"
                  href={waLink}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="group flex min-w-0 items-center gap-3 px-6 py-4 bg-[#BEAF87] text-[#0A0A0A] hover:bg-[#d4c59a] transition-colors"
                >
                  <MessageCircle size={18} />
                  <div className="flex-1 min-w-0">
                    <div className="text-[10px] uppercase tracking-[0.25em] opacity-70">
                      {t.agent.whatsapp}
                    </div>
                    <div className="font-[Barlow_Semi_Condensed] text-sm font-medium">
                      {agent.phoneDisplay}
                    </div>
                  </div>
                </a>

                <a
                  data-testid="agent-call"
                  href={telLink}
                  className="group flex min-w-0 items-center gap-3 px-6 py-4 border border-white/20 hover:border-[#BEAF87] hover:text-[#BEAF87] transition-colors"
                >
                  <Phone size={18} />
                  <div className="flex-1 min-w-0">
                    <div className="text-[10px] uppercase tracking-[0.25em] opacity-70">
                      {t.agent.call}
                    </div>
                    <div className="font-[Barlow_Semi_Condensed] text-sm font-medium">
                      {agent.phoneDisplay}
                    </div>
                  </div>
                </a>

                <a
                  data-testid="agent-email"
                  href={mailLink}
                  className="group flex min-w-0 items-center gap-3 px-6 py-4 border border-white/20 hover:border-[#BEAF87] hover:text-[#BEAF87] transition-colors"
                >
                  <Mail size={18} />
                  <div className="flex-1 min-w-0 overflow-hidden">
                    <div className="text-[10px] uppercase tracking-[0.25em] opacity-70">
                      {t.agent.email}
                    </div>
                    <div className="font-[Barlow_Semi_Condensed] text-sm font-medium truncate">
                      {agent.email}
                    </div>
                  </div>
                </a>

                <a
                  data-testid="agent-website"
                  href={agent.website}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="group flex min-w-0 items-center gap-3 px-6 py-4 border border-white/20 hover:border-[#BEAF87] hover:text-[#BEAF87] transition-colors"
                >
                  <Globe size={18} />
                  <div className="flex-1 min-w-0 overflow-hidden">
                    <div className="text-[10px] uppercase tracking-[0.25em] opacity-70">
                      {t.agent.website}
                    </div>
                    <div className="font-[Barlow_Semi_Condensed] text-sm font-medium truncate">
                      {websiteHost}
                    </div>
                  </div>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
